<script>
  import LocationPin from "../../icons/location.svg";


  export let city;
</script>
<style>
  .c-event-details__detail {
    display: flex;
    margin-top: 12px;
  }

  .c-event-details__icon {
    margin-right: 12px;
    display: flex;
    align-items: center;
  }
</style>


<div class="c-event-details__detail">
  <span class="c-event-details__icon">
    <LocationPin width="14" height="14" />
  </span>
  <span>{city}</span>
</div>

